<template>
    <v-card color="#F4FEFB">
        <v-container class="pr-14">
            <v-row>
                <v-col :cols="cols">
                    <canvas id="canvas" v-show="currentType==='seal'" ref="canvas" width="300" height="300"></canvas>
                    <canvas id="canvas" v-show="currentType==='square-seal'" ref="canvasSquare" width="405" height="405"></canvas>
                </v-col>
                <v-col cols="5">
                <v-row align="center">
                    <label-component horizontal="left">印影の種類</label-component>
                    <v-radio-group class="ml-5" v-model="currentType" v-on:change="changeType" row>
                        <v-radio label="丸印" value="seal"></v-radio>
                        <v-radio label="角印" value="square-seal"></v-radio>
                    </v-radio-group>
                </v-row>
                <v-row align="center">
                <label-component horizontal="left">入力</label-component>
                    <validation-provider v-slot="{ errors }" name="印影作成" rules="required|ivs_str_max:10">
                      <v-text-field
                        v-model="currentSealText"
                        v-show="currentType==='seal'"
                        outlined
                        @input="changeSeal"
                        background-color="white"
                        :error-messages="errors"
                        clearable
                        class="ml-4"
                      >
                      </v-text-field>
                    </validation-provider>
                <validation-provider v-slot="{ errors }" name="currentSquareSealText" :rules="{required:true, seal_ivs_str_max:{value:currentSquareSealText,max:10}}">
                  <v-textarea
                    v-model="currentSquareSealText"
                    v-show="currentType==='square-seal'"
                    outlined
                    wrap="off"
                    hide-details
                    @input="changeSeal"
                    background-color="white"
                    :error-messages="errors"
                    clearable
                    class="sealText ml-5"
                  >
                  </v-textarea>
                  <div v-if="error" class="errMessage ml-6 mt-3" v-html="errors[0]"></div>
                 </validation-provider>
                 </v-row>
                <v-row align="center" class="mt-5">
                <label-component horizontal="left">向き</label-component>
                    <v-radio-group class="ml-4" v-model="currentDirection" v-on:change="changeDirection" row>
                        <v-radio label="縦向き" :value="0"></v-radio>
                        <v-radio label="横向き" :value="1"></v-radio>
                    </v-radio-group>
                </v-row>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col
                    cols="3"
                >
                    <v-btn
                        block
                        color="white"
                        v-on:click="cancelSeal"
                    >
                        キャンセル
                    </v-btn>
                </v-col>
                <v-col
                    cols="3"
                >
                    <v-btn
                        block
                        color="red"
                        class="white--text"
                        v-on:click="registerSeal"
                        :disabled="invalid"
                    >
                        押印
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import { hankaku2Zenkaku } from '../../common/textUtil.js';
export default {
    props: ['sealText','direction','type'],
    data: function () {
        return {
            selectDestinations: [],
            currentDirection: 0,
            currentType: 'seal',
            invalid: true,
            currentSealText: '',
            currentSquareSealText: '',
            error: false,
            cols: 6
        }
    },
    created: function () {
        if(this.type == 'seal'){
            this.currentSealText = this.sealText?this.sealText:''
        }else{
            this.currentSquareSealText = this.sealText?this.sealText:''
        }
        this.currentDirection = this.direction?this.direction:0
        this.currentType = this.type?this.type:'seal'
        this.$nextTick(() => {
            if(this.type == 'seal'){
                this.createSeal(this.currentSealText,this.currentDirection);
            }else{
                this.createSquareSeal(this.currentSquareSealText,this.currentDirection);
            }
      })
    },
    methods: {
        cancelSeal: function () {
            this.$emit('cancelSeal')
        },
        registerSeal: function () {
            if(this.currentType == 'seal'){
                this.$emit('registerSeal', this.selectSealData, 40, 'seal')
            }else{
                this.$emit('registerSeal', this.selectSealData, 70, 'square-seal')
            }
        },
        createSeal: function(value,direction=0){
		    var canvas = this.$refs.canvas;
		    var context = canvas.getContext('2d');
		    
		    context.clearRect(0, 0, canvas.width, canvas.height);
		    let graphemesplit = require("graphemesplit")
		    let x=canvas.width/2;
		    let y=canvas.height/2;
		    let radius= 140;
		    let textList = value ? graphemesplit(value) : [];
		    let count = textList.length;
            let fontSize = count > 1?(radius * 2 - context.lineWidth) / count : 180
            let str = ""
		    
		    context.lineWidth=5;
		    context.strokeStyle="#DA4033";
		    context.beginPath();
		    context.arc(x,y,radius,0,Math.PI*2);
		    context.stroke();
		    context.fillStyle = '#DA4033';
		    context.textAlign = 'center';
            context.textBaseline = 'middle';
    		context.font = "500 " + fontSize + "px 'Noto Sans JP'";
    		
    		if(direction == 0){
                y = count > 1? (canvas.height - radius*2 + context.lineWidth)/2 + fontSize/2: radius+15;
		    }else{
		        x = count > 1? (canvas.width - radius*2 + context.lineWidth)/2 + fontSize/2: radius+15;
		    }
		    
		    textList.forEach((str) => {
	            context.save();
                if (/[-ー～]/.test(str) && direction===0) { // -ー～は90度回転
                    context.translate(x, y);
                    context.rotate(90 * Math.PI / 180);
                    context.translate(-x, -y);
                }else if(/[_＿]/.test(str)){
                    context.translate(0,-fontSize/9);
                }else if(/[gpqyj]/.test(str)){
                    context.translate(0,-fontSize/8);
                }
                context.fillText(str,x,y);
                context.restore();
                
                if(direction == 0){
                    y+=fontSize;
    		    }else{
    		        x+=fontSize;
    		    }
		    });
            this.selectSealData = canvas.toDataURL("image/png",1.0);
	    },
	    createSquareSeal: async function (value,direction=0){
	        
            let canvas = this.$refs.canvasSquare;
            let context = canvas.getContext('2d')
            
            context.clearRect(0, 0, canvas.width, canvas.height);
            
            let graphemesplit = require("graphemesplit")
            canvas.style.letterSpacing = '0px';
            let fontFamily = 'Noto Sans JP'
            let color = '#DA4033'
            let lineWidth = 5
            
            context.fillStyle = color
            context.strokeStyle = color
            context.lineWidth = lineWidth
            context.beginPath();
            context.roundRect(lineWidth/2, lineWidth/2, canvas.width-lineWidth, canvas.height-lineWidth, 15);
            context.stroke();
            
            let wide = canvas.width
            let high = canvas.height
          
            let textList = []
            let count = 0
            let fontSize = 0
            let x = 0
            let y = 0
            let str = ''
            let margins = 50
            
            var splitedText = value != null?value.split('\n'):[];
            context.fillStyle = color
            
            if(direction == 0){
                context.textBaseline = 'middle'
                context.textAlign = 'center'
                for (let index = splitedText.length-1; index >= 0; index--) {
                    textList = splitedText[index] ? graphemesplit(splitedText[index]) : [];
                    count = textList.length
                    fontSize = (wide - lineWidth*2) / count
                    x = (wide/splitedText.length)/2 + (splitedText.length-index-1)*(wide/splitedText.length)
                    y = lineWidth/2 + (wide - lineWidth)/count/2
                    
                    context.save()
                    context.font = `500 ${fontSize}px ${fontFamily}`
                    
                    textList.forEach((item) => {
                        str = hankaku2Zenkaku(item);
                        context.save();
                        
                        let scaleX = ((wide - lineWidth*2)/splitedText.length)/fontSize
                        let scaleY = (high+lineWidth+margins)/(fontSize*count)
                        
                        if(/[acenorsuvxz]/.test(str)){
                            context.scale(scaleX*1.8, scaleY*1.3);
                            context.translate(0,-fontSize/10);
                            context.fillText(str,x/scaleX/1.8,y/scaleY/1.3);
                        }else if(/[mw]/.test(str)){
                            context.scale(scaleX, scaleY*1.3);
                            context.translate(0,-fontSize/10);
                            context.fillText(str,x/scaleX,y/scaleY/1.3);
                        }else if(/[bdfhiklt]/.test(str)){
                            context.scale(scaleX*1.8, scaleY);
                            context.fillText(str,x/scaleX/1.8,y/scaleY);
                        }else if(/[gpqy]/.test(str)){
                            context.scale(scaleX*1.8, scaleY*1.1);
                            context.translate(0,-fontSize/5);
                            context.fillText(str,x/scaleX/1.8,y/scaleY/1.1);
                        }else if(/[j]/.test(str)){
                            context.scale(scaleX*1.8, scaleY/1.1);
                            context.translate(0,-fontSize/10);
                            context.fillText(str,x/scaleX/1.8,y/scaleY*1.1);
                        }else if(/[_＿]/.test(str)){
                            context.scale(scaleX, scaleY);
                            context.translate(0,-fontSize/10);
                            context.fillText(str,x/scaleX,y/scaleY);
                        }else{
                            context.scale(scaleX, scaleY);
                            if (/[-ー～]/.test(str) && direction===0) { // -ー～は90度回転
                                context.translate(x/scaleX,y/scaleY);
                                context.rotate(90 * Math.PI / 180);
                                context.translate(-x/scaleX, -y/scaleY);
                            }
                            context.fillText(str,x/scaleX,y/scaleY);
                        }
                        context.restore();
    
                        y+=fontSize;
                    })
                }
            }else{
                context.textBaseline = 'middle'
                context.textAlign = 'left'
                fontSize = (high - lineWidth) / splitedText.length
                for (let index = 0; index < splitedText.length; index++) {
                    textList = splitedText[index] ? graphemesplit(splitedText[index]) : [];
                    count = textList.length
                    x = lineWidth
                    y = (high/splitedText.length)/2 + (index)*(high/splitedText.length)
                    
                    context.save()
                    context.font = `500 ${fontSize}px ${fontFamily}`
                    let textsWidth = this.getTextsWidth(context,textList)
                    let scaleX = (wide - lineWidth*2)/textsWidth
                    let scaleY = (high/splitedText.length)/fontSize
                    textList.forEach((item) => {
                        str = hankaku2Zenkaku(item);
                        context.save();
                        
                        if(/[gpqyj]/.test(str)){
                            context.scale(scaleX, scaleY/1.2);
                            context.translate(0,-fontSize/10);
                            context.fillText(str,x/scaleX,y/scaleY*1.2);
                        }else if(/[_＿]/.test(str)){
                            context.scale(scaleX, scaleY);
                            context.translate(0,-fontSize/15);
                            context.fillText(str,x/scaleX,y/scaleY);
                        }else{
                            context.scale(scaleX, scaleY);
                            context.fillText(str,x/scaleX,y/scaleY);
                        }
                        context.restore();
                        x+=this.getActualWidth(context,str)*scaleX;
                    })

                }
            }
            
            this.selectSealData = canvas.toDataURL("image/png",1.0);
      },
	    changeSeal: function (value) {
            if(this.currentType == 'seal'){
                this.createSeal(value,this.currentDirection)
                this.checkWords('seal',value)
            }else{
                this.createSquareSeal(value,this.currentDirection)
                this.checkWords('square-seal',value)
            }
            this.$emit('changeSealText', value)
        },
        changeDirection: function () {
            if(this.currentType == 'seal'){
                this.createSeal(this.currentSealText == null? "":this.currentSealText,this.currentDirection)
            }else{
                this.createSquareSeal(this.currentSquareSealText == null? "":this.currentSquareSealText,this.currentDirection)
            }
            this.$emit('changeSealDirection', this.currentDirection)
            this.$emit('changeSealType', this.currentType)
        },
        changeType: function () {
            if(this.currentType == 'seal'){
                this.error = false
                this.createSeal(this.currentSealText == null? "":this.currentSealText,this.currentDirection)
                this.checkWords('seal',this.currentSealText == null? "":this.currentSealText)
                this.cols = 6
            }else{
                this.error = true
                this.createSquareSeal(this.currentSquareSealText == null? "":this.currentSquareSealText,this.currentDirection)
                this.checkWords('square-seal',this.currentSquareSealText == null? "":this.currentSquareSealText)
                this.cols = 7
            }
            this.$emit('changeSealDirection', this.currentDirection)
            this.$emit('changeSealType', this.currentType)
        },
        checkWords: function (type,newVal){
            let graphemesplit = require("graphemesplit")
            let invalid = false
            
            if(typeof newVal == "undefined" || newVal == null || newVal == ""){
                invalid = true
            }
            
            if(type == 'seal'){
                let textList = newVal ? graphemesplit(newVal) : [];
                if(textList.length > 10){
                    invalid = true;
                }else{
                    textList.every((item) => {
                        if(item.trim() != ""){
                            invalid = false
                            return false
                        }else{
                            invalid = true;
                            return true
                        }
                    })
                }
            }else{
                var splitedText = newVal != null?newVal.split('\n'):[];
                if(splitedText.length > 10){
                    invalid = true;
                }
    
                splitedText.every((item) => {
                    let textList = item ? graphemesplit(item) : [];
                    if(textList.length > 10){
                        invalid = true;
                        return false
                    }else{
                        return true
                    }
                    
                })
                
                if(!invalid){
                    let status = true
                    splitedText.forEach((item) => {
                        let textList = item ? graphemesplit(item) : [];
                        if(textList.length == 0 && status){
                            invalid = true;
                        }
                        textList.every((item) => {
                            if(item.trim() != ""){
                                invalid = false
                                status = false
                                return false
                            }else{
                                if(status){
                                    invalid = true;
                                }
                                return true
                            }
                        })
                    })
                }
            }
            
            this.invalid = invalid;
        },
        getActualHeight: function (ctx,str) {
          const { actualBoundingBoxAscent, actualBoundingBoxDescent } = ctx.measureText(str);
          return actualBoundingBoxAscent + actualBoundingBoxDescent;
        },
        getActualWidth: function (ctx,str) {
          return ctx.measureText(str).width;
        },
        getTextsWidth: function (ctx,textList) {
          let textsWidth = 0
          textList.forEach((item) => {
              textsWidth += this.getActualWidth(ctx,hankaku2Zenkaku(item))
          })
          return textsWidth;
        },
        getTextsHeight: function (ctx,textList) {
          let textsHeight = 0
          textList.forEach((item) => {
              textsHeight += this.getActualHeight(ctx,hankaku2Zenkaku(item))
          })
          return textsHeight;
        },
    },
    watch: {
        currentSquareSealText: function(newVal, oldVal) {
            this.checkWords('square-seal',newVal)
        },
        currentSealText: function(newVal, oldVal) {
            this.checkWords('seal',newVal)
        }
    },
}
</script>

<style scoped>
    /*!
     * "Noto Sans JP" is lisenced under the SIL Open Font License 1.1
     * http://fonts.googleapis.com
     * https://www.google.com/fonts/attribution
     * http://scripts.sil.org/OFL
     */
    @font-face {
        font-family: 'Noto Sans JP';
        src: url('/documents/fonts/NotoSansJP-Regular.otf');
    }
    
    ::v-deep .v-input__slot{
        width: 300px;
    }
    
    .sealText::v-deep textarea {
        overflow: hidden;
    }
    
    .errMessage{
        font-size: 1.5rem !important;
        color: red;
    }
</style>